// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4aa9137d","239":"430eea77","455":"88c2e477"}[chunkId] + ".chunk.js";
};